import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import isEmpty from 'is-empty';

import Header from '../Header';
import Sidebar from '../Sidebar';
import Trendingslider from '../trendingslider';

import Buycard from "./Buycard";
import PrivateBuycard from "../Privatesale/LaunchpadBuycard"
import Marquee from "react-fast-marquee";
import vector_green1 from "../../images/chainpad/pcr.png";
import vector_greenss from "../../images/chainpad/redcircle.png";
import Web3 from "web3";
import '../../css/styles.css';

import coin from "../../images/coin.png"
import favicon from "../../images/chainpad/logo.png"
import Spinner from 'react-bootstrap/Spinner';

import loader from "../../images/loader.gif"
import { getlaunchpaddatalimit, getLaunchpadsaleCardLimit, getmycontributiondatalimit, getPrivatesaleCardLimit, getSaleCards, getSaleCardsLimit, getsaledatalimit, getTotalSalesInfo, searchCards, searchSale } from '../../hooks/useProjects';
import { Dropdown, Nav, Tab, Row, Col, Container, ProgressBar, InputGroup, Form, Alert } from 'react-bootstrap';
import { CHAINS, AdminTokenAddress } from '../../config/env'
import { getAccount, getChainId, setChainId } from '../../hooks/useAccount';
import { UseTokenInfo, getSaleInfoCard, checkNativeTokens } from '../../hooks/useContract';
import { gettrendingdisplayhook, getusecreatedlaunchhook, getuserdatahook, getallsalehook } from '../../hooks/usebackend';
import { privatesalefilterby, privatesalesortby, tokenfilter, tokenfilterlaunchpad } from '../../hooks/filter';

import bgstyle2 from "../../images/bg_style2.png";

import bgstyle from "../../images/bg_style.png";

import bgoutline1 from "../../images/bg_outline1.png";
import whiteoutline1 from "../../images/outline-white1.png";

import bgoutline from "../../images/bg_outline.png";
import whiteoutline from "../../images/outline-white.png";
import bgoutline2 from "../../images/bg_outline2.png";
import whiteoutline2 from "../../images/outline-white2.png";


import eye from "../../images/chainpad/eye.png";
import eyehover from "../../images/chainpad/eyehover.png";
import menu from "../../images/chainpad/menu.png";
import menuhover from "../../images/chainpad/menuhover.png";
import money from "../../images/chainpad/money.png";
import moneyhover from "../../images/chainpad/moneyhover.png";
import heart from "../../images/chainpad/heart.png";
import hearthover from "../../images/chainpad/hearthover.png";
import Launchpadbanner from './Launchpadbanner';




class LaunchpadList1 extends Component {

  showLoader() {
    document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 0.5;
    document.getElementById("loader_div").classList.remove("d-none");
    document.getElementById("loader_div").classList.add("d-block");
  }

  hideLoader() {
    document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 1;
    document.getElementById("loader_div").classList.remove("d-block");
    document.getElementById("loader_div").classList.add("d-none");
  }

  closeAllMenusStatus() {
    this.setState({ closeKycmenu: true });
    this.setState({ closeHcmenu: true });
    this.setState({ closeCoinmenu: true });
  }

  closeAllMenusKyc() {
    this.setState({ closeStatusmenu: true });
    this.setState({ closeHcmenu: true });
    this.setState({ closeCoinmenu: true });
  }

  closeAllMenusCoin() {
    this.setState({ closeStatusmenu: true });
    this.setState({ closeHcmenu: true });
    this.setState({ closeKycmenu: true });
  }


  closeAllMenusHc() {
    this.setState({ closeStatusmenu: true });
    this.setState({ closeCoinmenu: true });
    this.setState({ closeKycmenu: true });
  }

  // menuToggle(e)
  // {
  //   console.log(e,"fsd");
  //   console.log(this.state.closeHcmenu,"fdsf");
  // }



  componentDidMount() {

    document.getElementById("home_grad_aprent").classList.remove("active");
    document.getElementById("home_grad_aprent").classList.add("active");
    // this.showLoader();
    this.hideLoader();
    // document.getElementById("launchpad_parent").classList.add("active");
    this.trendingData();

    this.setState({ currentChain: getChainId() });
    this.gettrending();
    this.getuserdata();
    this.loadData();
    this.tokenInfo()
    // this.getdummylaunchpad()
  }

  async gettrending() {
    let data = await gettrendingdisplayhook();
    console.log("dataa trending", data?.data?.data);
    if (data?.data?.data?.length > 0)
      this.setState({ trending: data?.data?.data })
  }

  getuserdata = async () => {
    const totalsale = await getTotalSalesInfo();
    let userdata = await getuserdatahook(this.state.accountInfo && this.state.accountInfo.toLowerCase());
    console.log("userdata", userdata?.data?.data, "users", userdata?.data?.data?.wishlist);
    this.setState({ userData: userdata?.data?.data })
    // this.setState({investedpools : userdata.data.data.investedpools})
    // this.setState({wishlist : userdata.data.data.wishlist})
    // this.setState({viewlist : userdata.data.data.viewlist})
    // this.setState({investedamount : userdata.data.data.investedamount})
    // const totalproxydata = userdata.data.data.launchpad.filter(data => data.iswhitelist == true)
    // console.log("totalproxydata" , totalproxydata);
    let totalproxydata = userdata?.data?.data?.launchpad;
    let newarray = [];
    totalproxydata?.map((val, i) => {
      let newvalue = totalsale?.find((e) => e._sale == val.saleaddress);
      if (newvalue !== undefined) {
        newarray.push(newvalue)
      }
    })
    console.log("userdatanewly", newarray);
    this.setState({ mycontribution: newarray.reverse() })
  }

  // getdummylaunchpad = async() => {
  //   let dummylaunchpad = await getusecreatedlaunchhook();
  //   var dummylaunch = [];
  //   console.log("get dummy launchpad" , dummylaunchpad);
  //   if(dummylaunchpad?.data?.type == "success"){
  //     dummylaunch = dummylaunchpad?.data?.data?.filter(data => data?.whitelist != "privatesale");
  //     this.setState({dummylaunchpad : dummylaunch})
  //   }
  //   // newtotalproxy = newtotalproxy.concat(dummylaunch)
  // }

  constructor(props) {
    super(props);
    this.state = {

      parnetcard: [

        { "id": 1, "image": vector_green1, "name": "SBMT" }, { "id": 2, "image": vector_green1, "name": "PCR" }, { "id": 3, "image": vector_green1, "name": "BESC" }, { "id": 4, "image": vector_green1, "name": "SKEWER" }, { "id": 5, "image": vector_green1, "name": "PCR" }
      ],

      proxy: [],
      totalSales: [],
      onGoingSales: [],
      upComingSales: [],
      isSearch: false,
      searchSale: [],
      search: '',
      interval: 3,
      loadInterval: 3,
      searchInterval: 3,
      searchProxy: [],
      isLoading: false,
      currentChain: 0,
      closeHcmenu: false,
      closeCoinmenu: false,
      closeKycmenu: false,
      closeStatusmenu: false,
      isuser: false,
      button: true,
      mycontribution: [],
      accountInfo: getAccount(),
      interval: 0,
      loadinterval: 3,
      original: [],
      filterdata: "All Status",
      sortdata: "No Filter",
      coin: [],
      status: [],
      type: [],
      trending: [],
      dummylaunchpad: [],
      userData: [],
      Proxydata: [],
      favorites: [],
      favoriteCount: 0,
      trendingData: [],
      tokeninfo: {},
      tokenBalance: 0,

      activeKey: "second",
      hoveredKey: null
    };
  }


  handleSelect = (selectedKey) => {
    this.setState({ activeKey: selectedKey });
  };


  handleMouseEnter = (key) => {
    this.setState({ hoveredKey: key });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredKey: null });
  };

  sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

  //     async loadData(){
  //       this.showLoader();
  //       const Proxydata = await getTotalSalesInfo();
  //       console.log("Proxydata",Proxydata);
  //       const totalproxydata = Proxydata.filter(data => data._isWhitelisted == false)
  //       let trenddata = await gettrendingdisplayhook();
  //       console.log("dataa trending" , trenddata?.data?.data);
  //       if(trenddata?.data?.data?.length > 0)
  //       this.setState({trending : trenddata?.data?.data})
  //       var trending = trenddata?.data?.data
  //       console.log("trendingdataaaaaaaaaaaaaa" , trending);
  //       let newtotalproxy = [];
  //         trending.map((val , i)=>{
  //           let singledata = totalproxydata.find(e=>e?._sale == val.saleaddress);
  //           if(singledata){
  //             newtotalproxy.push(singledata)
  //           }
  //         })
  // //add on works
  //         // let dummylaunchpad = await getusecreatedlaunchhook();
  //         // var dummylaunch = [];
  //         // console.log("get dummy launchpad" , dummylaunchpad);
  //         // if(dummylaunchpad?.data?.type == "success"){
  //         //   dummylaunch = dummylaunchpad?.data?.data?.filter(data => data?.whitelist != "privatesale");
  //         //   this.setState({dummylaunchpad : dummylaunch})
  //         //   newtotalproxy = dummylaunch ? newtotalproxy.concat(dummylaunch) : []
  //         // }



  //         totalproxydata.map((datas , i) => {
  //           let singlesale = newtotalproxy.find(e=>e._sale == datas?._sale);
  //           if(!singlesale){
  //             newtotalproxy.push(datas)
  //           }
  //         })
  //         this.setState({ proxy : newtotalproxy })
  //         console.log("trendingdataaaaaaaaaaaaaa" , newtotalproxy);
  //       console.log("total proxy data" , totalproxydata);
  //       // this.setState({ proxy : totalproxydata })
  //       this.setState({ original : newtotalproxy })
  //       const total = await getlaunchpaddatalimit(newtotalproxy , 0 , this.state.loadinterval);
  //       console.log("total>>>" , total);
  //       // const total = await getPrivatesaleCardLimit(Proxydata,0,this.state.interval , this.state.isuser);
  //       // console.log("button " ,Proxydata?.length , total.index );
  //       // if(Proxydata?.length == total.index || !total){
  //       //   this.setState({button : false})
  //       // }
  //       // await this.sleep(1000)
  //       //  this.setState({ totalSales: total.saleInfoCards });  
  //       //  this.setState({ interval: total.index+1 }); 
  //       this.setState({ totalSales: total });  
  //        this.setState({ interval: this.state.loadinterval}); 
  //       this.hideLoader();
  //   }




  async tokenInfo() {
    const token = await UseTokenInfo(AdminTokenAddress);
    console.log(token, AdminTokenAddress, "tokeninfo_launchList")
    this.setState({ tokeninfo: token });
    console.log(this.state.tokeninfo, "tokeninfo_")
    var balance = await checkNativeTokens(getAccount(), AdminTokenAddress);
    console.log("balance", localStorage.getItem("accountInfo"), parseFloat(balance / 10 ** (token?.decimals)))
    // this.setState({ tokenBalance: parseFloat(balance / 10 ** (token.decimals)) })
    console.log("tokenBalance", this.state.tokenBalance);
  }



  async loadData() {
    try {
      this.showLoader();
      this.setState({ totalSales: [] });
      const Proxydata = await getTotalSalesInfo();
      console.log("Proxydata", Proxydata);
      this.setState({ Proxydata: Proxydata })
      // const totalproxydata = Proxydata.filter(data => data._isWhitelisted == false)
      let trenddata = await gettrendingdisplayhook();
      console.log("dataa trending", trenddata?.data?.data);
      if (trenddata?.data?.data?.length > 0)
        this.setState({ trending: trenddata?.data?.data })
      var trending = trenddata?.data?.data
      console.log("trendingdataaaaaaaaaaaaaa", trending, this.state.trending);
      let newtotalproxy = [];
      trending?.map((val, i) => {
        let singledata = Proxydata?.find(e => e?._sale == val.saleaddress);
        if (singledata) {
          newtotalproxy.push(singledata)
        }
      })
      //add on works
      // let dummylaunchpad = await getusecreatedlaunchhook();
      // var dummylaunch = [];
      // console.log("get dummy launchpad" , dummylaunchpad);
      // if(dummylaunchpad?.data?.type == "success"){
      //   dummylaunch = dummylaunchpad?.data?.data?.filter(data => data?.whitelist != "privatesale");
      //   this.setState({dummylaunchpad : dummylaunch})
      //   newtotalproxy = dummylaunch ? newtotalproxy.concat(dummylaunch) : []
      // }



      Proxydata?.map((datas, i) => {
        let singlesale = newtotalproxy.find(e => e._sale == datas?._sale);
        if (!singlesale) {
          newtotalproxy.push(datas)
        }
      })
      this.setState({ proxy: newtotalproxy })
      console.log("newtotalproxy", newtotalproxy);
      console.log("total proxy data", Proxydata);
      // this.setState({ proxy : totalproxydata })
      this.setState({ original: newtotalproxy })
      const total = await getlaunchpaddatalimit(newtotalproxy, 0, this.state.loadinterval);
      console.log("total>>>", total);
      // const total = await getPrivatesaleCardLimit(Proxydata,0,this.state.interval , this.state.isuser);
      // console.log("button " ,Proxydata?.length , total.index );
      // if(Proxydata?.length == total.index || !total){
      //   this.setState({button : false})
      // }
      // await this.sleep(1000)
      //  this.setState({ totalSales: total.saleInfoCards });  
      //  this.setState({ interval: total.index+1 }); 
      this.setState({ totalSales: total });
      this.setState({ interval: this.state.loadinterval });
      this.hideLoader();
    }
    catch (err) {
      console.log("total_err", err)
    }
  }

  async loadMore() {
    console.log("Lad moreee", this.state.totalSales.length < this.state.proxy.length)
    this.setState({ isLoading: true });
    const newly = await getlaunchpaddatalimit(this.state.proxy, this.state.interval, this.state.interval + this.state.loadInterval);
    console.log("newly ", newly);
    const total = this.state.totalSales.concat(newly);
    this.setState({ totalSales: total, interval: this.state.interval + this.state.loadInterval });
    this.setState({ isLoading: false });
  }

  async loadmycontribution() {
    this.showLoader()
    this.setState({ totalSales: [] });
    // this.setState({ isLoading: true});
    this.setState({ proxy: this.state.mycontribution })
    const newly = await getmycontributiondatalimit(this.state.mycontribution, 0, this.state.loadInterval);
    console.log("newly ", newly, this.state.mycontribution, this.state.loadInterval);
    this.setState({ totalSales: newly });
    //  this.setState({ isLoading: false});
    this.hideLoader();
  }

  // async searchloadMoremycontribution(){
  //   console.log("Lad more",this.state.totalSales.length < this.state.proxy.length)
  //   this.setState({ isLoading: true});
  //   const newly = await getmycontributiondatalimit(this.state.searchProxy,this.state.searchInterval,this.state.searchInterval+this.state.loadInterval);
  //   const total = this.state.searchSale.concat(newly);
  //   await this.sleep(1000)
  //    this.setState({ searchSale: total,searchInterval: this.state.searchInterval+this.state.loadInterval });
  //    this.setState({ isLoading: false});   
  // }

  async loadMoremycontribution() {
    console.log("Lad more", this.state.totalSales.length < this.state.proxy.length)
    this.setState({ isLoading: true });
    const newly = await getmycontributiondatalimit(this.state.mycontribution, this.state.interval, this.state.interval + this.state.loadInterval);
    console.log("newly ", newly);
    const total = this.state.totalSales.concat(newly);
    // if(this?.state?.proxy?.length == newly.index || !newly.saleInfoCards){
    //   console.log("button");
    //   this.setState({button : false})
    // }
    // await this.sleep(1000)
    //  this.setState({ totalSales: total,interval: this.state.interval+this.state.loadInterval });
    this.setState({ totalSales: total, interval: this.state.interval + this.state.loadInterval });
    this.setState({ isLoading: false });
    //  this.setState({ isLoading: false});   
  }

  async loadSearchMore() {
    console.log("Lad more", this.state.totalSales.length < this.state.proxy.length)
    this.setState({ isLoading: true });
    const newly = await getlaunchpaddatalimit(this.state.searchProxy, this.state.searchInterval, this.state.searchInterval + this.state.loadInterval);
    const total = this.state.searchSale.concat(newly);
    await this.sleep(1000)
    this.setState({ searchSale: total, searchInterval: this.state.searchInterval + this.state.loadInterval });
    this.setState({ isLoading: false });
  }

  async handleChange(e) {
    if ((e.target.value).length > 0) {
      if (e.key === 'Enter') {
        console.log("Search : ", e.target.value)
        this.showLoader();
        const searchS = await searchCards(this.state.proxy, e.target.value);
        this.setState({ searchProxy: searchS });
        const data = await getlaunchpaddatalimit(searchS, 0, this.state.searchInterval);
        await this.sleep(1050)
        console.log("Search sale : ", searchS)
        this.setState({ searchSale: data, isSearch: true })
        this.hideLoader();
        this.handlegetkyc()
      }
    } else {
      this.setState({ isSearch: false })
    }

  }
  handlegetkyc = async () => {
    let auditkycinfo = await getallsalehook();
    if (auditkycinfo?.data?.data?.length > 0) {
      this.setState({ auditkyc: auditkycinfo?.data?.data })
    }

    let singleaudit = auditkycinfo?.data?.data?.find(e => e.saleaddress == window.location.pathname.split('/')[2])
    console.log("auditkuycinfo", auditkycinfo?.data?.data, singleaudit);

    if (singleaudit)
      this.setState({ singleaudit: singleaudit })
  }

  async nouser() {
    this.setState({ isuser: false });
    // this.setState({loadInterval : 3});
    this.setState({ interval: 0 });
    this.setState({ searchInterval: 3 });
    // this.setState({button : true});
    this.setState({
      filterdata: "All Status",
      sortdata: "No Filter",
    })
    // this.setState({ isSearch: true})
    await this.loadData()
  }

  async yesuser() {
    this.setState({ isuser: true });
    // this.setState({loadInterval : 3});
    this.setState({ interval: 3 });
    this.setState({ searchInterval: 3 });
    // this.setState({button : true})
    // this.setState({ isSearch: true})
    this.setState({
      filterdata: "All Status",
      sortdata: "No Filter",
    })
    await this.loadmycontribution()

  }

  async myfavorites() {
    // this.setState({ isuser: true });
    let userdata = await getuserdatahook(this.state.accountInfo && this.state.accountInfo.toLowerCase());
    console.log("userdata", userdata?.data?.data, "users", userdata?.data?.data?.wishlist);
    this.setState({ userData: userdata?.data?.data })
    // this.setState({loadInterval : 3});
    this.setState({ interval: 3 });
    this.setState({ searchInterval: 3 });
    // this.setState({button : true})
    // this.setState({ isSearch: true})
    this.setState({
      filterdata: "All Status",
      sortdata: "No Filter",
    })
    await this.loadFavorites()

  }


  async loadFavorites() {
    this.setState({ totalSales: [] });
    console.log("loadFavorites", this.state.Proxydata, this.state.userData)
    // var newtotalproxy=[]
    var favorite = []
    let trenddata = await gettrendingdisplayhook();
    console.log("dataa trending", trenddata?.data?.data);
    if (trenddata?.data?.data?.length > 0)
      this.setState({ trending: trenddata?.data?.data })
    var trending = trenddata?.data?.data
    console.log("trendingdataaaaaaaaaaaaaa", trending);
    let newtotalproxy = [];
    trending?.map((val, i) => {
      let singledata = this.state.Proxydata.find(e => e?._sale == val.saleaddress);
      if (singledata) {
        newtotalproxy.push(singledata)
      }
    })

    this.state.Proxydata.map((datas, i) => {
      let singlesale = newtotalproxy.find(e => e._sale == datas?._sale);
      if (!singlesale) {
        newtotalproxy.push(datas)
      }
    })
    this.setState({ proxy: newtotalproxy })
    console.log("trendingdataaaaaaaaaaaaaa", newtotalproxy);
    console.log("total proxy data", this.state.Proxydata);
    this.setState({ original: newtotalproxy })
    const total = await getlaunchpaddatalimit(newtotalproxy, 0, newtotalproxy.length);

    console.log("total>>>", total);
    let favoriteCount = 0
    this.state.userData?.wishlist?.map((datas, i) => {
      let match = total?.find(val => val?.saleAddress === datas?.saleaddress)
      console.log(match, "favorites_datas")
      if (match) {
        if (favorite.length < 4) {
          favorite.push(match)
        }
        favoriteCount = favoriteCount + 1
      }
    })
    this.setState({ favorites: favorite, favoriteCount: favoriteCount })
    console.log("newtotalproxy_loadFavorites", this.state.userData?.wishlist, this.state.favorites, favorite)
    //  if(this.state.userData.wishlist.saleaddress === newtotalproxy._sale){

    //  }
  }
  async loadMoreFavorites() {
    this.setState({ totalSales: [] });
    console.log("loadFavorites", this.state.Proxydata, this.state.userData)
    // var newtotalproxy=[]
    var favorite = []
    let trenddata = await gettrendingdisplayhook();
    console.log("dataa trending", trenddata?.data?.data);
    if (trenddata?.data?.data?.length > 0)
      this.setState({ trending: trenddata?.data?.data })
    var trending = trenddata?.data?.data
    console.log("trendingdataaaaaaaaaaaaaa", trending);
    let newtotalproxy = [];
    trending?.map((val, i) => {
      let singledata = this.state.Proxydata.find(e => e?._sale == val.saleaddress);
      if (singledata) {
        newtotalproxy.push(singledata)
      }
    })

    this.state.Proxydata.map((datas, i) => {
      let singlesale = newtotalproxy.find(e => e._sale == datas?._sale);
      if (!singlesale) {
        newtotalproxy.push(datas)
      }
    })
    this.setState({ proxy: newtotalproxy })
    console.log("trendingdataaaaaaaaaaaaaa", newtotalproxy);
    console.log("total proxy data", this.state.Proxydata);
    this.setState({ original: newtotalproxy })
    const total = await getlaunchpaddatalimit(newtotalproxy, 0, newtotalproxy.length);

    console.log("total>>>", total);
    let favoriteCount = 0
    this.state.userData?.wishlist?.map((datas, i) => {
      let match = total?.find(val => val?.saleAddress === datas?.saleaddress)
      console.log(match, "favorites_datas")
      if (match) {
        if (favorite.length < this.state.interval + this.state.loadInterval) {
          favorite.push(match)
        }
        favoriteCount = favoriteCount + 1
      }
    })
    this.setState({ favorites: favorite, favoriteCount: favoriteCount, interval: this.state.interval + this.state.loadInterval })
    console.log("newtotalproxy_loadFavorites", this.state.userData?.wishlist, this.state.favorites, favorite)
    //  if(this.state.userData.wishlist.saleaddress === newtotalproxy._sale){

    //  }
  }
  // async loadMoremyfavorites() {
  //   console.log("Lad more", this.state.totalSales.length < this.state.proxy.length)
  //   this.setState({ isLoading: true });
  //   const newly = await getmycontributiondatalimit(this.state.mycontribution, this.state.interval, this.state.interval + this.state.loadInterval);
  //   console.log("newly ", newly);
  //   const total = this.state.totalSales.concat(newly);
  //   // if(this?.state?.proxy?.length == newly.index || !newly.saleInfoCards){
  //   //   console.log("button");
  //   //   this.setState({button : false})
  //   // }
  //   // await this.sleep(1000)
  //   //  this.setState({ totalSales: total,interval: this.state.interval+this.state.loadInterval });
  //   this.setState({ totalSales: total, interval: this.state.interval + this.state.loadInterval });
  //   this.setState({ isLoading: false });
  //   //  this.setState({ isLoading: false});   
  // }


  async handlefilter(val) {
    if (val == "All Status") {
      this.setState({ filterdata: val });
      this.setState({ button: true })
      this.loadData();
    }
    else {
      this.showLoader();
      this.setState({ button: true })
      this.setState({ filterdata: val });
      var filtered = await privatesalefilterby(this.state.original, val, this.state.isuser);
      console.log("filtered", filtered);
      // var saleinfo = await getPrivatesaleFilter(filtered , this.state.isuser);
      this.setState({ proxy: filtered })
      if (filtered.length > 0) {
        const total = await getlaunchpaddatalimit(filtered, 0, this.state.loadInterval);
        console.log("button ", filtered?.length, total);

        if (filtered?.length == 0) {
          this.setState({ totalSales: filtered })
        }
        await this.sleep(1000)
        this.setState({ totalSales: total });
        this.setState({ interval: 3 });
        this.hideLoader();
      }
      else {
        // this.setState({button : false})
        this.setState({ totalSales: filtered });
        this.hideLoader();
      }
    }
  }

  async handlesort(val) {
    if (val == "No Filter") {
      this.setState({ button: true })
      this.loadData();
      this.setState({ sortdata: val })
    }
    else {
      this.showLoader();
      this.setState({ sortdata: val })
      this.setState({ button: true });
      var sorted = await privatesalesortby(this.state.original, val, this.state.isuser);
      console.log("sorted", sorted);
      this.setState({ proxy: sorted });
      if (sorted.length > 0) {
        const total = await getLaunchpadsaleCardLimit(sorted, 0, this.state.interval, this.state.isuser);
        console.log("button ", sorted?.length, total);

        if (sorted?.length == total.index || !total) {
          this.setState({ button: false })
        }
        await this.sleep(1000)
        this.setState({ totalSales: total.saleInfoCards });
        this.setState({ interval: total.index + 1 });
        this.hideLoader();
      }
      else {
        this.setState({ button: false })
        this.setState({ totalSales: sorted });
        this.hideLoader();
      }
    }
  }

  async handlecoin(val) {
    var coins = this.state.coin
    if (coins.length == 0) {
      coins.push(val);
    }
    else {
      if (coins.includes(val)) {
        const index = coins.indexOf(val);
        if (index > -1) {
          coins.splice(index, 1);
        }
      }
      else {
        coins.push(val)
      }
    }
    console.log("coin", coins);
    this.setState({ coin: coins })
  }

  async handlestatus(val) {
    var statuss = this.state.status
    if (statuss.length == 0) {
      statuss.push(val);
    }
    else {
      if (statuss.includes(val)) {
        const index = statuss.indexOf(val);
        if (index > -1) {
          statuss.splice(index, 1);
        }
      }
      else {
        statuss.push(val)
      }
    }
    console.log("status", statuss);
    this.setState({ status: statuss })
  }

  async handletype(val) {
    var statuss = this.state.type
    if (statuss.length == 0) {
      statuss.push(val);
    }
    else {
      if (statuss.includes(val)) {
        const index = statuss.indexOf(val);
        if (index > -1) {
          statuss.splice(index, 1);
        }
      }
      else {
        statuss.push(val)
      }
    }
    console.log("status", statuss);
    this.setState({ type: statuss })
  }

  async handleadvancefilter() {
    this.showLoader();
    if (this.state.coin.length == 0 && this.state.status.length == 0 && this.state.type.length == 0) {
      this.loadData();
    }
    else {
      // let filtered = await tokenfilter(this.state.proxy , this.state.coin , this.state.status);
      let filtered = await tokenfilterlaunchpad(this.state.proxy, this.state.coin, this.state.status, this.state.type);
      this.setState({ proxy: filtered })
      console.log("filtered", filtered);
      if (filtered.length > 0) {
        const total = await getlaunchpaddatalimit(filtered, 0, this.state.interval);
        console.log("button ", filtered?.length, total);
        // if(filtered?.length == 0){
        //   this.setState({button : false})
        // }
        await this.sleep(1000)
        this.setState({ totalSales: total });
        this.setState({ interval: 3 });
        this.hideLoader();
      }
      else {
        this.setState({ button: false })
        this.setState({ totalSales: filtered });
        this.hideLoader();
      }
    }
    this.hideLoader();
  }




  async trendingData() {
    try {
      const totalsale = await getTotalSalesInfo();
      console.log("trendingData_totalsale", totalsale);
      var totalproxy = [];
      // totalsale && totalsale.map(async (val, i) => {
      //   let data = await getSaleInfoCard(val._sale);
      //   totalproxy.push(data);
      // })
      for (let i = 0; i < totalsale.length; i++) {
        let data = await getSaleInfoCard(totalsale[i]._sale);
        totalproxy.push(data);
      }
      console.log("totalproxy1", totalproxy);
      var sortedtotalproxy = totalproxy.sort((a, b) => (parseFloat(a.participants) > parseFloat(b.participants)) ? 1 : -1);
      console.log("totalproxy", sortedtotalproxy[0], sortedtotalproxy.length);

      this.setState({ trendingData: sortedtotalproxy });
    }
    catch (err) {
      console.log("err", err)
    }
  }

  render() {
    const location = this.props.location.pathname.split('/')[1];
    const { totalSales, onGoingSales, upComingSales, search, isSearch, searchSale, accountInfo } = this.state
    console.log("totalproxy", this.state.trendingData)

    const { activeKey, hoveredKey } = this.state;

    const tabs = [
      { key: "first", label: "Quick View", img: eye, imgActive: eyehover, onClick: () => this.nouser() },
      { key: "second", label: "All Presales", img: menu, imgActive: menuhover, onClick: () => this.nouser() },
      { key: "third", label: "My Contributions", img: money, imgActive: moneyhover, onClick: () => this.yesuser() },
      { key: "fourth", label: "My Favorites", img: heart, imgActive: hearthover, onClick: () => this.myfavorites() }
    ];


    return (
      <div id="loader_main">
        <div id="loader_div">
          <span className="spin_round">

          </span>
          <img src={favicon} className="logo_load" />
        </div>
        <div className='logo_overlay' id="logo_overlay">


          <Header onUpdate={this.loadData.bind(this)} />

          <div className="whole_sec pb-5">
            <div className='flex_side_right'>
              <Sidebar />
              {/* ongoing_sec */}
              <div className='right_side_sec'>
                {/* <div className="text-white topBar d-flex justify-content-between">
                  
                  <small>Trending</small>
                <small>
                  #1&nbsp;<span>Husy</span>
                </small>
                <small>
                  #2&nbsp;<span>ORL</span>
                </small>
                <small>
                  #3&nbsp;<span>UWC</span>
                </small>
                <small>
                  #4&nbsp;<span>777</span>
                </small>
                <small>
                  #5&nbsp;<span>IDXS</span>
                </small>
                <small>
                  #6&nbsp;<span>COUGNU</span>
                </small>
                <small>
                  #7&nbsp;<span>CRICLE</span>
                </small>
                <small>
                  #8&nbsp;<span>KASA</span>
                </small>
                <small>
                  #9&nbsp;<span>FIFAPP</span>
                </small>
                <small>
                  #10&nbsp;<span>SOG</span>
                </small>
                <small>
                  #11&nbsp;<span>COOSHA</span>
                </small>
                <small>
                  #12&nbsp;<span>Honey</span>
                </small>
                
                
              </div> */}
                {/* <Trendingslider /> */}
                <div className="right_side_spacing">
                  <div className='ongoing_sec proj_bg pb-5'>
                    <div className="container px-1">
                      <div className='top_heqad_sec private_sec_bg mt-2 mt-md-0'>
                        <div className="bg_outline1">
                          {/* <img src={bgoutline1} className="out_dark"/>
                    <img src={whiteoutline1} className="out_light" /> */}
                        </div>

                      </div>
                    </div>

                    {/* <div className='row'>
                      <div className='col-md-4'>
                      <div className='MuiStack-root css-1jafzf3'>
                        <div className='MuiStack-root css-176oxo8'>
                          <div className='MuiStack-root css-1w3h7is'>
<div className='MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiCard-root css-1la37ta'>
  <p>
  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.

  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 


  </p>
</div>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div> */}

                    <div>

                      <div className='container-custom'>

                        {/* <Launchpadbanner /> */}
                        <div className="row mt-3 mb-4">
                          <div className="col-3 col-sm-4 col-md-3 padleft col-lg-3 col-xxl-2">
                            <div class="buttonborder">
                              <div class="animateborder">

                                <div class="fullbutton"><p class="buttonname">
                                  <span className='spotlights spot1'>Spotlight</span>
                                  {isEmpty(this.state.trendingData) ? <Spinner animation="border" role="status" className='ml-sm-2 ' size='sm' />
                                    : <span className='marlef'><img src={this.state.trendingData && this.state.trendingData[0]?.logo} className="img-fluid partnercard smallimg  ms-3" alt="banner" /> <span className='spotlights spot2'>{this.state.trendingData && this.state.trendingData[0]?.name}</span>
                                    </span>}
                                </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-9 col-sm-8 col-md-9 col-lg-9 padd col-xxl-10">
                            <div className="bordermarquee">
                              <div className="trending">
                                <p className="d-flex"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
                                  <path d="M4.93927 5.75018C5.10474 5.75018 5.23888 5.61603 5.23888 5.45056C5.23888 5.28508 5.10474 5.15094 4.93927 5.15094C4.77379 5.15094 4.63965 5.28508 4.63965 5.45056C4.63965 5.61603 4.77379 5.75018 4.93927 5.75018Z" fill="#FC7226" />
                                  <path d="M2.9151 13.7572C3.21514 13.7572 3.45837 13.514 3.45837 13.2139C3.45837 12.9139 3.21514 12.6707 2.9151 12.6707C2.61506 12.6707 2.37183 12.9139 2.37183 13.2139C2.37183 13.514 2.61506 13.7572 2.9151 13.7572Z" fill="#FC7226" />
                                  <path d="M4.03264 10.9324C4.19764 10.9324 4.3314 10.7986 4.3314 10.6336C4.3314 10.4686 4.19764 10.3348 4.03264 10.3348C3.86764 10.3348 3.73389 10.4686 3.73389 10.6336C3.73389 10.7986 3.86764 10.9324 4.03264 10.9324Z" fill="#FC7226" />
                                  <path d="M8.52344 8.44501C8.63994 8.44501 8.73438 8.35057 8.73438 8.23407C8.73438 8.11757 8.63994 8.02313 8.52344 8.02313C8.40694 8.02313 8.3125 8.11757 8.3125 8.23407C8.3125 8.35057 8.40694 8.44501 8.52344 8.44501Z" fill="#FC7226" />
                                  <path d="M3.93521 9.93882C3.0949 9.59443 0.93042 8.43384 0.93042 8.43384C0.93042 8.43384 1.12758 12.3943 2.22188 14.2988L2.22704 14.3074C2.24598 14.3407 2.2655 14.3731 2.28559 14.4047L2.30711 14.44C2.40441 14.5966 2.51782 14.7426 2.64548 14.8756L2.66097 14.8903C3.18095 15.4349 3.89078 15.7582 4.64295 15.793C5.39511 15.8277 6.13176 15.5714 6.69979 15.0771C7.92151 14.0155 8.11092 12.111 6.9908 10.9444C5.96883 9.88371 4.77552 10.2892 3.93521 9.93882Z" fill="#FC8223" />
                                  <path d="M11.6151 9.76664C12.4554 9.42225 14.6199 8.26166 14.6199 8.26166C14.6199 8.26166 14.4227 12.2221 13.3284 14.1266L13.3233 14.1352C13.3043 14.1685 13.2848 14.2009 13.2647 14.2325L13.2432 14.2678C13.1459 14.4244 13.0325 14.5704 12.9048 14.7034L12.8893 14.7181C12.3694 15.2627 11.6595 15.586 10.9074 15.6208C10.1552 15.6556 9.41856 15.3992 8.85053 14.9049C7.62881 13.8433 7.43939 11.9389 8.55952 10.7722C9.57718 9.71153 10.7748 10.1171 11.6151 9.76664Z" fill="#FC8223" />
                                  <path d="M13.5308 9.95345C12.347 6.19531 7.73216 0.616211 7.73216 0.616211C7.73216 0.616211 3.28696 6.16603 2.06352 9.7184C1.76028 10.39 1.60355 11.1185 1.60376 11.8553C1.60376 13.6479 2.52242 15.2433 3.95077 16.2713L4.00157 16.3074L4.11005 16.3823C5.19171 17.1158 6.47003 17.5048 7.77693 17.4981C11.1623 17.4981 13.9062 14.985 13.9062 11.8846C13.9055 11.2228 13.7781 10.5673 13.5308 9.95345Z" fill="#FC7226" />
                                  <path d="M12.5545 10.6448C11.5704 7.23535 7.73303 2.17456 7.73303 2.17456C7.73303 2.17456 4.03946 7.20866 3.02266 10.4321C2.60169 11.458 2.52701 12.5933 2.80998 13.6655C3.09295 14.7377 3.7181 15.6883 4.59049 16.3728L4.63267 16.4056L4.71877 16.4736C5.59808 17.1293 6.6656 17.4837 7.76251 17.484C8.85942 17.4843 9.92712 17.1305 10.8068 16.4752C11.6864 15.8198 12.331 14.8981 12.6447 13.847C12.9583 12.7958 12.9243 11.6716 12.5476 10.6414L12.5545 10.6448Z" fill="#FC8223" />
                                  <path d="M12.025 11.9776C11.1494 9.23197 7.73823 5.15613 7.73823 5.15613C7.73823 5.15613 4.45191 9.21044 3.54703 11.8054C3.32147 12.295 3.20401 12.8273 3.20264 13.3664C3.20264 14.6759 3.88194 15.8416 4.93749 16.5924L4.97452 16.6191L5.05459 16.6742C5.85626 17.2107 6.8003 17.4947 7.76493 17.4895C10.2669 17.4895 12.2962 15.6531 12.2962 13.3887C12.2977 12.9053 12.2056 12.4261 12.025 11.9776Z" fill="#FC9823" />
                                </svg> <span className="ml-2 hotsales">HOT</span></p>
                              </div>

                              <div className="allmarquee">
                                {isEmpty(this.state.trendingData) ?
                                  <div className='d-flex justify-content-center align-items-center w-100 h-100'>
                                    <Spinner animation="border" className='mb-2' role="status" size='md' />
                                  </div>
                                  :
                                  <Marquee speed={50} direction='left'>
                                    <div className="partnermarquee mt-1">
                                      {console.log("this.state.trending", this.state.trendingData)}
                                      {this.state.trendingData && this.state.trendingData?.map((e, i) =>
                                        <div className="partnerwidth">

                                          {console.log("e", e)}
                                          <div className='numberround'>
                                            <p className="mb-0">{i + 1}</p></div>
                                          <p className="mb-0 mx-2">{e?.name}</p>
                                          <img src={e?.logo} className="img-fluid partnercard ms-3" alt="banner" />
                                        </div>
                                      )}
                                    </div>
                                  </Marquee>}
                              </div>


                            </div>

                          </div>
                        </div></div>
                    </div>

                    <div className="inner_bg mt-4">
                      <div className="containerss px-1">
                        <Tab.Container defaultActiveKey="second">
                          <Row className="container-fluid w-100 mx-0 px-0">
                            <Col lg={12} className="px-0 mb-1">
                              <Nav
                                variant="pills"
                                className="nav_green"
                                activeKey={activeKey}
                                onSelect={this.handleSelect}
                              >
                                {tabs.map((tab) => {
                                  const isActive = activeKey === tab.key;
                                  const isHovered = hoveredKey === tab.key;
                                  const imgSrc = isActive || isHovered ? tab.imgActive : tab.img;
                                  return (
                                    <Nav.Item key={tab.key}>
                                      <Nav.Link eventKey={tab.key}
                                        onClick={tab.onClick}
                                        onMouseEnter={() => this.handleMouseEnter(tab.key)}
                                        onMouseLeave={this.handleMouseLeave}>
                                        <p className="tabfont mb-0 d-flex align-items-center">
                                          <img
                                            src={imgSrc}
                                            alt={tab.label}
                                            style={{ marginRight: 8 }}
                                          />
                                          {tab.label}
                                        </p>
                                      </Nav.Link>
                                    </Nav.Item>
                                  );
                                })}
                              </Nav>


                            </Col>
                            {/* <hr class="hr_yellow mt-0 mt-5 mb-3" /> */}

                            <Col lg={12} className="img_center_lg px-0">
                              <div className='containerss container_custom px-0'>
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    <div class="table-responsive adv_tab mt-3">
                                      <table className="table table_poricat_list">
                                        <tr>
                                          <th><InputGroup className="mb-3 input_group search_bar">
                                            <Form.Control
                                              placeholder="Search"
                                              aria-label="Recipient's username"
                                              aria-describedby="basic-addon2"
                                              value={this.state.search}
                                              onChange={(e) => { this.setState({ search: e.target.value }); this.handleChange(e); }}
                                              onKeyDown={(e) => this.handleChange(e)}
                                            />
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group"
                                            >
                                              <i class="fas fa-search"></i>
                                            </InputGroup.Text>
                                          </InputGroup></th>

                                          <th><InputGroup className="mb-3 fullwidths input_group input_group_prepend">
                                            <Form.Control
                                              value={"Type"}
                                              aria-label="Recipient's username"
                                              aria-describedby="basic-addon2"
                                            />
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group input_group_filteralign"
                                            >
                                              <i class="fa fa-sort" aria-hidden="true"></i>
                                            </InputGroup.Text>
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group input_group_filteralign"
                                            >
                                              <Dropdown className='filter_dropdown '>
                                                <Dropdown.Toggle id="dropdown-basic" className='table_filter_icon'>
                                                  <i class="fas fa-filter" onClick={() => { this.setState({ closeHcmenu: false }); this.closeAllMenusHc() }}></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className={this.state.closeHcmenu ? "table_dropdown_menu filter_menu d-none" : "table_dropdown_menu filter_menu d-block"}>
                                                  <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeHcmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input" id="customCheck1"
                                                      checked={this.state.type.includes("Launchpad") ? true : false}
                                                      onChange={() => this.handletype("Launchpad")}
                                                    />
                                                    <label className="custom-control-label" for="customCheck1">Launchpad</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeHcmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input" id="customCheck2"
                                                      checked={this.state.type.includes("Fairlaunch") ? true : false}
                                                      onChange={() => this.handletype("Fairlaunch")}
                                                    />
                                                    <label className="custom-control-label" for="customCheck2">Fairlaunch</label>
                                                  </div></Dropdown.Item>


                                                  {/* <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck3" />
  <label className="custom-control-label" for="customCheck3">Action</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck4" />
  <label className="custom-control-label" for="customCheck4">Subscription</label>
</div></Dropdown.Item> */}
                                                  <Dropdown.Divider />
                                                  <Dropdown.Item href="javascript:void(0)">
                                                    <div className='dropdown_buttons d-flex justify-content-between'>
                                                      <button className="get-started-btn explore-btn mr-2" onClick={() => { this.setState({ type: [] }) }}>Reset</button>
                                                      <button className="get-started-btn explore-btn" id="ok_hc" onClick={() => {
                                                        this.setState({ closeHcmenu: true });
                                                        this.handleadvancefilter()
                                                      }}>OK</button>
                                                    </div>
                                                  </Dropdown.Item>

                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </InputGroup.Text>
                                          </InputGroup></th>
                                          {/* <th><InputGroup className="mb-3 input_group input_group_prepend"> */}
                                          {/* <Form.Control
                        value="HC"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <InputGroup.Text
                        id="basic-addon2"
                        className="input_group input_group_filteralign"
                      >
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </InputGroup.Text> */}
                                          {/* <InputGroup.Text
                        id="basic-addon2"
                        className="input_group input_group_filteralign"
                      > */}
                                          {/* <Dropdown className='filter_dropdown '>
                        <Dropdown.Toggle id="dropdown-basic" className='table_filter_icon'>
                        <i class="fas fa-filter" onClick={()=>{this.setState({closeHcmenu:false})}}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={this.state.closeHcmenu?"table_dropdown_menu filter_menu d-none":"table_dropdown_menu filter_menu d-block"}>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck1" />
  <label className="custom-control-label" for="customCheck1">Presale</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck2" />
  <label className="custom-control-label" for="customCheck2">Fairlaunch</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck3" />
  <label className="custom-control-label" for="customCheck3">Action</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeHcmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck4" />
  <label className="custom-control-label" for="customCheck4">Subscription</label>
</div></Dropdown.Item>
<Dropdown.Divider />
<Dropdown.Item href="javascript:void(0)">
  <div className='dropdown_buttons d-flex justify-content-between'>
  <button className="get-started-btn mr-2">Reset</button>
  <button className="get-started-btn" id="ok_hc" onClick={()=>{this.setState({closeHcmenu:true})}}>OK</button>
  </div>
</Dropdown.Item>

      </Dropdown.Menu>
                        </Dropdown> */}
                                          {/* </InputGroup.Text>
                    </InputGroup></th> */}
                                          <th><InputGroup className="mb-3 fullwidths input_group">
                                            <Form.Control
                                              value="Coin"
                                              aria-label="Recipient's username"
                                              aria-describedby="basic-addon2"
                                              readOnly
                                            />
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group input_group_filteralign"
                                            >
                                              <Dropdown className='filter_dropdown'>
                                                <Dropdown.Toggle id="dropdown-basic" className='table_filter_icon'>
                                                  <i class="fas fa-filter" onClick={() => { this.setState({ closeCoinmenu: false }); this.closeAllMenusCoin() }}></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className={this.state.closeCoinmenu ? "table_dropdown_menu filter_menu d-none" : "table_dropdown_menu filter_menu d-block"}>
                                                  <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeCoinmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input"
                                                      checked={this.state.coin.includes("BNB") ? true : false}
                                                      id="customCheck5" onChange={() => this.handlecoin("BNB")} />
                                                    <label className="custom-control-label" for="customCheck5" >BNB</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeCoinmenu: false }) }}>
                                                    <input type="checkbox" onChange={() => this.handlecoin("DAI")}
                                                      checked={this.state.coin.includes("DAI") ? true : false}
                                                      className="custom-control-input" id="customCheck6" />
                                                    <label className="custom-control-label" for="customCheck6">DAI</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeCoinmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input"
                                                      checked={this.state.coin.includes("USDT") ? true : false}
                                                      onChange={() => this.handlecoin("USDT")} id="customCheck7" />
                                                    <label className="custom-control-label" for="customCheck7">USDT</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeCoinmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input"
                                                      checked={this.state.coin.includes("USDC") ? true : false}
                                                      onChange={() => this.handlecoin("USDC")} id="customCheck8" />
                                                    <label className="custom-control-label" for="customCheck8">USDC</label>
                                                  </div></Dropdown.Item>
                                                  {/* <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeCoinmenu:false})}}>
  <input type="checkbox" className="custom-control-input" onChange={()=>this.handlecoin("BNB")} id="customCheck9" />
  <label className="custom-control-label" for="customCheck9">BNB</label>
</div></Dropdown.Item> */}
                                                  {/* <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeCoinmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck10" />
  <label className="custom-control-label" for="customCheck10">MATIC</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeCoinmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck11" />
  <label className="custom-control-label" for="customCheck11">AVAX</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:viod(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeCoinmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck12" />
  <label className="custom-control-label" for="customCheck12">CRO</label>
</div></Dropdown.Item> */}
                                                  <Dropdown.Divider />
                                                  <Dropdown.Item href="javascript:viod(0)">
                                                    <div className='dropdown_buttons d-flex justify-content-between'>
                                                      <button className="get-started-btn explore-btn mr-2" onClick={() => this.setState({ coin: [] })}>Reset</button>
                                                      <button className="get-started-btn explore-btn" onClick={() => {
                                                        this.setState({ closeCoinmenu: true });
                                                        this.handleadvancefilter();
                                                      }}>OK</button>
                                                    </div>
                                                  </Dropdown.Item>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </InputGroup.Text>
                                          </InputGroup>
                                          </th>
                                          {/* <th><InputGroup className="mb-3 input_group">
                      <Form.Control
                        value="InitialCap"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <InputGroup.Text
                        id="basic-addon2"
                        className="input_group"
                      >
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </InputGroup.Text>
                    </InputGroup></th> */}
                                          {/* <th><InputGroup className="mb-3 input_group">
                      <Form.Control
                        value="KYC/Audit"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                       <InputGroup.Text
                        id="basic-addon2"
                        className="input_group input_group_filteralign"
                      >
                        <Dropdown className='filter_dropdown'>
                        <Dropdown.Toggle id="dropdown-basic" className='table_filter_icon'>
                        <i class="fas fa-filter" onClick={()=>{this.setState({closeKycmenu:false})}}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={this.state.closeKycmenu?"table_dropdown_menu filter_menu d-none":"table_dropdown_menu filter_menu d-block"}>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeKycmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck13" />
  <label className="custom-control-label" for="customCheck13">KYC</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeKycmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck14" />
  <label className="custom-control-label" for="customCheck14">Audit</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeKycmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck15" />
  <label className="custom-control-label" for="customCheck15">Safu</label>
</div></Dropdown.Item>
        <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={()=>{this.setState({closeKycmenu:false})}}>
  <input type="checkbox" className="custom-control-input" id="customCheck16" />
  <label className="custom-control-label" for="customCheck16">Doxx</label>
</div></Dropdown.Item>
<Dropdown.Divider />
<Dropdown.Item href="javascript:void(0)">
  <div className='dropdown_buttons d-flex justify-content-between'>
  <button className="get-started-btn mr-2">Reset</button>
  <button className="get-started-btn" onClick={()=>{this.setState({closeKycmenu:true})}}>OK</button>
  </div>
</Dropdown.Item>
      </Dropdown.Menu>
                        </Dropdown>
                      </InputGroup.Text>
                    </InputGroup>
                    </th> */}
                                          <th><InputGroup className="mb-3 fullwidths input_group">
                                            <Form.Control
                                              value="Status"
                                              aria-label="Recipient's username"
                                              aria-describedby="basic-addon2"
                                              readOnly
                                            />
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group"
                                            >
                                              <i class="fa fa-sort" aria-hidden="true"></i>
                                            </InputGroup.Text>
                                            <InputGroup.Text
                                              id="basic-addon2"
                                              className="input_group input_group_filteralign"
                                            >
                                              <Dropdown className='filter_dropdown'>
                                                <Dropdown.Toggle id="dropdown-basic" className='table_filter_icon'>
                                                  <i class="fas fa-filter" onClick={() => { this.setState({ closeStatusmenu: false }); this.closeAllMenusStatus() }}></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className={this.state.closeStatusmenu ? "table_dropdown_menu filter_menu d-none" : "table_dropdown_menu filter_menu d-block"}>
                                                  <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeStatusmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input"
                                                      checked={this.state.status.includes("Upcoming") ? true : false}
                                                      onChange={() => this.handlestatus("Upcoming")} id="customCheck17" />
                                                    <label className="custom-control-label" for="customCheck17">Upcoming</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeStatusmenu: false }) }}>
                                                    <input type="checkbox" className="custom-control-input" id="customCheck18"
                                                      checked={this.state.status.includes("Live") ? true : false}
                                                      onChange={() => this.handlestatus("Live")} />
                                                    <label className="custom-control-label" for="customCheck18">Live</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Item href="javascript:void(0)"><div className="custom-control custom-checkbox" onClick={() => { this.setState({ closeStatusmenu: false }) }}>
                                                    <input type="checkbox" checked={this.state.status.includes("Ended") ? true : false}
                                                      className="custom-control-input" id="customCheck19" onChange={() => this.handlestatus("Ended")} />
                                                    <label className="custom-control-label" for="customCheck19">Ended</label>
                                                  </div></Dropdown.Item>
                                                  <Dropdown.Divider />
                                                  <Dropdown.Item href="javascript:void(0)">
                                                    <div className='dropdown_buttons d-flex justify-content-between'>
                                                      <button className="get-started-btn explore-btn mr-2" onClick={() => this.setState({ status: [] })}>Reset</button>
                                                      <button className="get-started-btn explore-btn" onClick={() => {
                                                        this.setState({ closeStatusmenu: true });
                                                        this.handleadvancefilter();
                                                      }}>OK</button>
                                                    </div>
                                                  </Dropdown.Item>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </InputGroup.Text>
                                          </InputGroup></th>
                                          {/* <th></th>
                                          <th></th>

                                          <th></th>

                                          <th></th>

                                          <th></th>

                                          <th></th>

                                          <th></th> */}

                                          {/* <th><InputGroup className="mb-3 input_group">
                      <Form.Control
                        value="Links"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                    </InputGroup></th>
                    <th><InputGroup className="mb-3 input_group">
                      <Form.Control
                        value="TGOnline"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <InputGroup.Text
                        id="basic-addon2"
                        className="input_group"
                      >
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </InputGroup.Text>
                    </InputGroup></th>
                    <th><InputGroup className="mb-3 input_group">
                      <Form.Control
                        value="Countdown"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <InputGroup.Text
                        id="basic-addon2"
                        className="input_group"
                      >
                        <i class="fa fa-sort" aria-hidden="true"></i>
                      </InputGroup.Text>
                    </InputGroup></th> */}
                                        </tr>


                                        <tr className='currenthead'>
                                          <th>Name</th>
                                          <th>Sales Type</th>
                                          <th>Coin</th>
                                          <th>Symbol</th>
                                          <th>Softcap</th>
                                          <th>Hardcap</th>
                                          <th>Percentage</th>
                                          <th>Start Date</th>
                                          <th>End Date</th>
                                          <th>Edit</th>
                                        </tr>


                                        {!isSearch ?
                                          (totalSales && totalSales.map((data) => <>
                                            {console.log("index", data)}
                                            <tr>
                                              <td><span className="d-flex align-items-center">

                                                <div className="relative_token_div  mr-2">
                                                  <img className="token_image_sm " src={data?.logo} />
                                                </div>
                                                {data?.name}
                                              </span></td>
                                              <td>{data?.LaunchpadType ? "Launchpad" : "Fairlaunch"}</td>
                                              <td>{data?.coin}</td>
                                              <td>{data?.symbol}</td>
                                              <td>{data?.softCap / 10 ** 18}</td>
                                              <td>{data?.hardCap / 10 ** 18}</td>
                                              {/* <td><span className="close_icons">
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover active_times"></i>
        </span></td> */}
                                              {/* {console.log("parseInt(parseInt(saleInfo?.earnedCap)/parseInt(saleInfo?.hardCap) * 100)", parseInt(parseInt(saleInfo?.earnedCap) / parseInt(saleInfo?.softCap) * 100))} */}
                                              <td>
                                                {console.log("parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)", data?.earnedCap, data?.softCap, data?.symbol, parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100))}

                                                {data?.LaunchpadType ? <><ProgressBar now={data && parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} className='yellow_bar mt-3' />
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <span className='desc_grey_txt'>{parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} % </span>
                                                    <span className='desc_grey_txt'>{((data?.earnedCap) / 10 ** data?.decimals).toFixed(2)}/{((data?.softCap) / 10 ** data?.decimals).toFixed(2)} </span>
                                                  </div></>
                                                  :
                                                  <><ProgressBar now={data && parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} className='yellow_bar mt-3' />
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <span className='desc_grey_txt'>{data && parseInt(parseInt(data.earnedCap) / parseInt(data.softCap) * 100)} % </span>
                                                      <span className='desc_grey_txt'>{data && ((data.earnedCap) / 10 ** data?.decimals).toFixed(2)} / {(parseInt(data?.softCap) / 10 ** data?.decimals).toFixed(2)} {this.state.buyToken} </span>
                                                    </div></>

                                                }
                                              </td>
                                              {/* <td><ProgressBar now={data?.earnedCap/10 ** data?.decimals} label={data?.hardCap} className='yellow_bar'/></td> */}
                                              {/* <td><span>
          <a href={data?.social[1] ? data?.social[1] : ""} target = "_blank"><i class="fas fa-globe green_icons"></i></a>
          <a href={data?.social[1] ? data?.social[1] : ""} target = "_blank"><i class="fab fa-skype green_icons"></i></a>
          <a href={data?.social[5] ? data?.social[5] : ""} target = "_blank"><i class="fab fa-telegram-plane green_icons"></i></a>
        </span></td> */}
                                              <td className="table_time">{new Date(data?.startTime * 1000)?.getDate() + "/" + new Date(data?.startTime * 1000)?.getMonth() + "/" +
                                                new Date(data?.startTime * 1000)?.getFullYear() + " " + new Date(data?.startTime * 1000)?.getHours() + ":" +
                                                new Date(data?.startTime * 1000)?.getMinutes() + ":" + new Date(data?.startTime * 1000)?.getSeconds()}</td>
                                              <td className="table_time">{new Date(data?.endTime * 1000)?.getDate() + "/" + new Date(data?.endTime * 1000)?.getMonth() + "/" +
                                                new Date(data?.endTime * 1000)?.getFullYear() + " " + new Date(data?.endTime * 1000)?.getHours() + ":" +
                                                new Date(data?.endTime * 1000)?.getMinutes() + ":" + new Date(data?.endTime * 1000)?.getSeconds()}</td>
                                              {/* <td><a className="link_text">Disable</a></td> */}
                                              <td><a className="link_text" href={`/launchpaddetail/${data?.saleAddress}`}>View</a></td>
                                            </tr>
                                          </>

                                          )) :
                                          (searchSale && searchSale.map((data) => <>
                                            {/* {console.log("index" , index)} */}
                                            <tr>
                                              <td><span className="d-flex align-items-center">

                                                <div className="relative_token_div  mr-2">
                                                  <img className="token_image_sm " src={data?.logo} />
                                                </div>
                                                {data?.name}
                                              </span></td>
                                              <td>{data?.LaunchpadType ? "Launchpad" : "Fairlaunch"}</td>
                                              <td>{data?.coin}</td>
                                              <td>{data?.symbol}</td>
                                              <td>{data?.softCap / 10 ** 18}</td>
                                              <td>{data?.hardCap / 10 ** 18}</td>
                                              {/* <td><span className="close_icons">
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover"></i>
          <i className="far fa-times-circle times_hover active_times"></i>
        </span></td> */}








                                              ;

                                              {/* <td><ProgressBar now={parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} className='yellow_bar mt-3' />
                                                <div className="d-flex align-items-center justify-content-between">
                                                  <span className='desc_grey_txt'>{parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} % </span>
                                                  <span className='desc_grey_txt'>{((data?.earnedCap) / 10 ** data?.decimals).toFixed(3)}/{((data?.softCap) / 10 ** data?.decimals).toFixed(2)} </span>
                                                </div>
                                              </td> */}



                                              {console.log("parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)", data?.earnedCap, data?.softCap, data?.symbol, parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100))}
                                              {data?.LaunchpadType ? <><ProgressBar now={data && parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} className='yellow_bar mt-3' />
                                                <div className="d-flex align-items-center justify-content-between">
                                                  <span className='desc_grey_txt'>{parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} % </span>
                                                  <span className='desc_grey_txt'>{((data?.earnedCap) / 10 ** data?.decimals).toFixed(3)}/{((data?.softCap) / 10 ** data?.decimals).toFixed(2)} </span>
                                                </div></>
                                                :
                                                <><ProgressBar now={data && parseInt(parseInt(data?.earnedCap) / parseInt(data?.softCap) * 100)} className='yellow_bar mt-3' />
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <span className='desc_grey_txt'>{data && parseInt(parseInt(data.earnedCap) / parseInt(data.softCap) * 100)} % </span>
                                                    <span className='desc_grey_txt'>{data && ((data.earnedCap) / 10 ** data?.decimals).toFixed(3)} / {(parseInt(data?.softCap) / 10 ** data?.decimals).toFixed(2)} {this.state.buyToken} </span>
                                                  </div></>

                                              }





                                              {/* <td><ProgressBar now={data?.earnedCap/10 ** data?.decimals} label={data?.hardCap} className='yellow_bar'/></td> */}
                                              {/* <td><span>
          <a href={data?.social[1]} target = "_blank"><i class="fas fa-globe green_icons"></i></a>
          <a href={data?.social[1]} target = "_blank"><i class="fab fa-skype green_icons"></i></a>
          <a href={data?.social[5]} target = "_blank"><i class="fab fa-telegram-plane green_icons"></i></a>
        </span></td> */}
                                              <td className="table_time">{new Date(data?.startTime * 1000)?.getDate() + "/" + new Date(data?.startTime * 1000)?.getMonth() + "/" +
                                                new Date(data?.startTime * 1000)?.getFullYear() + " " + new Date(data?.startTime * 1000)?.getHours() + ":" +
                                                new Date(data?.startTime * 1000)?.getMinutes() + ":" + new Date(data?.startTime * 1000)?.getSeconds()}</td>
                                              <td className="table_time">{new Date(data?.endTime * 1000)?.getDate() + "/" + new Date(data?.endTime * 1000)?.getMonth() + "/" +
                                                new Date(data?.endTime * 1000)?.getFullYear() + " " + new Date(data?.endTime * 1000)?.getHours() + ":" +
                                                new Date(data?.endTime * 1000)?.getMinutes() + ":" + new Date(data?.endTime * 1000)?.getSeconds()}</td>
                                              <td><a className="link_text">View</a></td>
                                            </tr>
                                          </>

                                          ))
                                        }
                                      </table>
                                    </div>
                                    <div className='text-center mt-5'>
                                      {isSearch ?
                                        <>
                                          {searchSale && searchSale.length < this.state.searchProxy.length ?

                                            <button className="get-started-btn explore-btn" onClick={this.loadSearchMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                            : <></>
                                          }
                                        </> : <>
                                          {totalSales && totalSales.length < this.state.proxy.length ?
                                            <button className="get-started-btn explore-btn" onClick={this.loadMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                            : <div className='row mt-5'>
                                              <div className='col-12'>
                                                <p className='no_data_txt'>No Data</p>
                                              </div>
                                            </div>
                                          }
                                        </>
                                      }

                                    </div>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    <div className='row_div matop'>
                                      <div>
                                        <div className='row justify-content-between align-items-end'>
                                          <div className='col-12 col-md-5 col-lg-5 chainpadsearch col-xl-3 mb-2 mb-md-0 mt-2'>
                                            <p className='label_input invisible'>Search</p>

                                            <input className="form-control allsearch searc_style_2" value={search} type="text" onChange={(e) => { this.setState({ search: e.target.value }); this.handleChange(e); }} onKeyDown={(e) => this.handleChange(e)} placeholder="Enter token name or token symbol" aria-label="Search" />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                              <path d="M15.0237 13.9847L12.1904 11.1597C13.1045 9.99508 13.6006 8.55691 13.5987 7.07637C13.5987 5.75783 13.2077 4.46889 12.4752 3.37257C11.7426 2.27624 10.7014 1.42176 9.48327 0.917171C8.2651 0.412587 6.92466 0.280565 5.63145 0.5378C4.33824 0.795034 3.15036 1.42997 2.21801 2.36232C1.28566 3.29467 0.650717 4.48256 0.393482 5.77577C0.136247 7.06897 0.268269 8.40942 0.772854 9.62759C1.27744 10.8458 2.13192 11.887 3.22825 12.6195C4.32458 13.352 5.61351 13.743 6.93205 13.743C8.4126 13.7449 9.85076 13.2489 11.0154 12.3347L13.8404 15.168C13.9179 15.2461 14.01 15.3081 14.1116 15.3504C14.2131 15.3928 14.322 15.4145 14.4321 15.4145C14.5421 15.4145 14.651 15.3928 14.7525 15.3504C14.8541 15.3081 14.9462 15.2461 15.0237 15.168C15.1018 15.0906 15.1638 14.9984 15.2061 14.8968C15.2484 14.7953 15.2702 14.6864 15.2702 14.5764C15.2702 14.4664 15.2484 14.3574 15.2061 14.2559C15.1638 14.1543 15.1018 14.0622 15.0237 13.9847ZM1.93205 7.07637C1.93205 6.08746 2.2253 5.12076 2.7747 4.29852C3.32411 3.47627 4.105 2.83541 5.01863 2.45697C5.93226 2.07853 6.9376 1.97952 7.9075 2.17244C8.87741 2.36537 9.76832 2.84157 10.4676 3.54083C11.1668 4.2401 11.6431 5.13101 11.836 6.10092C12.0289 7.07082 11.9299 8.07615 11.5514 8.98979C11.173 9.90342 10.5321 10.6843 9.7099 11.2337C8.88766 11.7831 7.92096 12.0764 6.93205 12.0764C5.60597 12.0764 4.3342 11.5496 3.39652 10.6119C2.45883 9.67422 1.93205 8.40245 1.93205 7.07637Z" fill="#868686" />
                                            </svg>
                                          </div>
                                          {/* <div className='col-6 col-md-3 col-xl-3'>

                                          </div> */}
                                          <div className='d-flex  fullside col-12 col-md-7 col-lg-7 col-xl-8 pt-3'>
                                            <div className='filterbutton'>

                                              <Dropdown className='dropdown_normal' >
                                                {/* <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                  ETH, BSC, o…
                                                  <p className='label_input labelname'> Networks</p>
                                                </Dropdown.Toggle> */}

                                                {/* <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                  <Dropdown.Item ><p>All Status</p></Dropdown.Item> */}
                                                {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                {/* <Dropdown.Item key={"up"}><p>ETH, BSC, o…</p></Dropdown.Item>
                                                  <Dropdown.Item><p>ETH, BSC, o…</p></Dropdown.Item> */}
                                                {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                {/* <Dropdown.Item><p >ETH, BSC, o…</p></Dropdown.Item> */}
                                                {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                {/* </Dropdown.Menu> */}
                                              </Dropdown>


                                            </div>
                                            <div className='filterbutton ml-3'>

                                              <Dropdown className='dropdown_normal' >
                                                <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                  {this.state.filterdata}
                                                  <p className='label_input labelname'>Filter By</p>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                  <Dropdown.Item ><p onClick={(e) => this.handlefilter("All Status")}>All Status</p></Dropdown.Item>
                                                  {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                  <Dropdown.Item key={"up"}><p onClick={(e) => this.handlefilter("Upcoming")}>Upcoming</p></Dropdown.Item>
                                                  <Dropdown.Item><p onClick={(e) => this.handlefilter("Live")}>Live</p></Dropdown.Item>
                                                  {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                  <Dropdown.Item><p onClick={(e) => this.handlefilter("Ended")}>Ended</p></Dropdown.Item>
                                                  {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </div>
                                            <div className='filterbutton ml-3'>

                                              <Dropdown className='dropdown_normal'>
                                                <Dropdown.Toggle variant="success" id="dropdown-basic-1">
                                                  {/* No Filter */}{this.state.sortdata}
                                                  <p className='label_input labelname'>Sort By</p>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='dropdown_normal_menu'>
                                                  <Dropdown.Item><p onClick={(e) => this.handlesort("No Filter")}>No Filter</p></Dropdown.Item>
                                                  {/* <Dropdown.Item>Hard Cap</Dropdown.Item>
                      <Dropdown.Item>Soft Cap</Dropdown.Item>
                      <Dropdown.Item>LP Percent</Dropdown.Item> */}
                                                  <Dropdown.Item><p onClick={(e) => this.handlesort("Start Time")}>Start Time</p></Dropdown.Item>
                                                  <Dropdown.Item><p onClick={(e) => this.handlesort("End Time")}>End Time</p></Dropdown.Item>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                    {totalSales?.length > 0 ?
                                      <>
                                        <div className='row mt-5 length_last'>
                                          {console.log("this.state.Proxydata", this.state.Proxydata, this.state.Proxydata._isWhitelisted, totalSales)}
                                          {!isSearch ?

                                            (totalSales && totalSales?.map((index) =>

                                              index.isWhitelisted === false ? <Buycard saleData={index} tokenInfo={this.state.tokenBalance} user={true} connect={"string"} /> :
                                                <PrivateBuycard saleData={index} tokenInfo={this.state.tokenBalance} user={false} connect={"string"} />
                                            )) :
                                            (searchSale && searchSale?.map((index) =>
                                              index._isWhitelisted === false ? <Buycard saleData={index} tokenInfo={this.state.tokenBalance} user={true} connect={"string"} /> :
                                                <PrivateBuycard saleData={index} user={false} tokenInfo={this.state.tokenBalance} connect={"string"} />

                                            ))
                                          }
                                        </div>
                                        <div className='text-center mt-3'>
                                          {/* { this.state.button ? isSearch  ?
              <>
            {searchSale && searchSale.length < this.state.searchProxy.length ? 
            ( !this.state.isLoading ?
            <button className="get-started-btn" onClick={this.loadSearchMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools' }</button>: <img src={loader}  id="loader_div_sm" />)
            :<></>
            }
            </> :  <>
            {totalSales && totalSales.length < this.state.proxy.length ? 
            ( !this.state.isLoading ?
            <button className="get-started-btn" onClick={this.loadMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools' }</button>: <img src={loader}  id="loader_div_sm" />)
            :<></>
            }
            </> : <></>
            } */}


                                          {isSearch ?
                                            <>
                                              {searchSale && searchSale?.length < this.state.searchProxy?.length ?

                                                <button className="get-started-btn explore-btn" onClick={this.loadSearchMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                : <></>
                                              }
                                            </> : <>
                                              {totalSales && totalSales?.length < this.state.proxy?.length ?
                                                <button className="get-started-btn explore-btn" onClick={this.loadMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                : <></>
                                              }
                                            </>
                                          }

                                          {/* {this.state.totalSales.length < this.state.proxy.length ?
            <button className="get-started-btn" 
            onClick={this.loadMore.bind(this)} id="load_more_btn">
              {this.state.isLoading ? 'Loading...' : 'View More Pools' }</button>
              : <></>
          } */}



                                        </div>
                                      </> :
                                      <div className='row mt-5'>
                                        <div className='col-12'>
                                          <p className='no_data_txt'>No Data</p>
                                        </div>
                                      </div>
                                    }
                                  </Tab.Pane>

                                  <Tab.Pane eventKey="third">
                                    <div className="tab_img">
                                      <div className='row_div'>
                                        <div>
                                          <div className='row_div'>
                                            <div>
                                              <div className='row justify-content-between align-items-end'>
                                                <div className='col-12 col-md-5 col-lg-5 chainpadsearch col-xl-4 mb-2 mb-md-0 mt-2'>
                                                  <p className='label_input invisible'>Search</p>

                                                  <input className="form-control allsearch searc_style_2" value={search} type="text" onChange={(e) => { this.setState({ search: e.target.value }); this.handleChange(e); }} onKeyDown={(e) => this.handleChange(e)} placeholder="Enter token name or token symbol" aria-label="Search" />
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M15.0237 13.9847L12.1904 11.1597C13.1045 9.99508 13.6006 8.55691 13.5987 7.07637C13.5987 5.75783 13.2077 4.46889 12.4752 3.37257C11.7426 2.27624 10.7014 1.42176 9.48327 0.917171C8.2651 0.412587 6.92466 0.280565 5.63145 0.5378C4.33824 0.795034 3.15036 1.42997 2.21801 2.36232C1.28566 3.29467 0.650717 4.48256 0.393482 5.77577C0.136247 7.06897 0.268269 8.40942 0.772854 9.62759C1.27744 10.8458 2.13192 11.887 3.22825 12.6195C4.32458 13.352 5.61351 13.743 6.93205 13.743C8.4126 13.7449 9.85076 13.2489 11.0154 12.3347L13.8404 15.168C13.9179 15.2461 14.01 15.3081 14.1116 15.3504C14.2131 15.3928 14.322 15.4145 14.4321 15.4145C14.5421 15.4145 14.651 15.3928 14.7525 15.3504C14.8541 15.3081 14.9462 15.2461 15.0237 15.168C15.1018 15.0906 15.1638 14.9984 15.2061 14.8968C15.2484 14.7953 15.2702 14.6864 15.2702 14.5764C15.2702 14.4664 15.2484 14.3574 15.2061 14.2559C15.1638 14.1543 15.1018 14.0622 15.0237 13.9847ZM1.93205 7.07637C1.93205 6.08746 2.2253 5.12076 2.7747 4.29852C3.32411 3.47627 4.105 2.83541 5.01863 2.45697C5.93226 2.07853 6.9376 1.97952 7.9075 2.17244C8.87741 2.36537 9.76832 2.84157 10.4676 3.54083C11.1668 4.2401 11.6431 5.13101 11.836 6.10092C12.0289 7.07082 11.9299 8.07615 11.5514 8.98979C11.173 9.90342 10.5321 10.6843 9.7099 11.2337C8.88766 11.7831 7.92096 12.0764 6.93205 12.0764C5.60597 12.0764 4.3342 11.5496 3.39652 10.6119C2.45883 9.67422 1.93205 8.40245 1.93205 7.07637Z" fill="#868686" />
                                                  </svg>
                                                </div>
                                                <div className='d-flex  fullside col-12 col-md-7 col-lg-7 col-xl-8 pt-3'>
                                                  <div className='filterbutton'>
                                                    <Dropdown className='dropdown_normal' >
                                                      {/* <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                        ETH, BSC, o…
                                                        <p className='label_input labelname'> Networks</p>
                                                      </Dropdown.Toggle> */}

                                                      {/* <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                        <Dropdown.Item ><p>All Status</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                      {/* <Dropdown.Item key={"up"}><p>ETH, BSC, o…</p></Dropdown.Item>
                                                        <Dropdown.Item><p>ETH, BSC, o…</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                      {/* <Dropdown.Item><p >ETH, BSC, o…</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                      {/* </Dropdown.Menu> */}
                                                    </Dropdown></div>
                                                  <div className='filterbutton ml-3'>

                                                    <Dropdown className='dropdown_normal' >
                                                      <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                        {this.state.filterdata}
                                                        <p className='label_input labelname'>Filter By</p>
                                                      </Dropdown.Toggle>

                                                      <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                        <Dropdown.Item ><p onClick={(e) => this.handlefilter("All Status")}>All Status</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                        <Dropdown.Item key={"up"}><p onClick={(e) => this.handlefilter("Upcoming")}>Upcoming</p></Dropdown.Item>
                                                        <Dropdown.Item><p onClick={(e) => this.handlefilter("Live")}>Live</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                        <Dropdown.Item><p onClick={(e) => this.handlefilter("Ended")}>Ended</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                      </Dropdown.Menu>
                                                    </Dropdown></div>
                                                  <div className='filterbutton ml-3'>
                                                    <Dropdown className='dropdown_normal'>
                                                      <Dropdown.Toggle variant="success" id="dropdown-basic-1">
                                                        {this.state.sortdata}
                                                        <p className='label_input labelname'>Sort By</p>
                                                      </Dropdown.Toggle>

                                                      <Dropdown.Menu className='dropdown_normal_menu'>
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("No Filter")}>No Filter</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Hard Cap</Dropdown.Item>
                      <Dropdown.Item>Soft Cap</Dropdown.Item>
                      <Dropdown.Item>LP Percent</Dropdown.Item> */}
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("Start Time")}>Start Time</p></Dropdown.Item>
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("End Time")}>End Time</p></Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </div>
                                                </div>
                                                {/* <div className='col-6 col-md-3 col-xl-2'>
                                                
                                                  
                                                </div> */}
                                              </div>

                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                      {console.log(totalSales, "totalSales")}
                                      {totalSales?.length > 0 ?
                                        <>
                                          <div className='row mt-5 length_last'>

                                            {!isSearch ?

                                              (totalSales && totalSales?.map((index) =>

                                                index.isWhitelisted === false ? <Buycard saleData={index} user={true} tokenInfo={this.state.tokenBalance} connect={"string"} /> :
                                                  <PrivateBuycard saleData={index} user={false} connect={"string"} />
                                              )) :
                                              (searchSale && searchSale?.map((index) =>
                                                index._isWhitelisted === false ? <Buycard saleData={index} user={true} tokenInfo={this.state.tokenBalance} connect={"string"} /> :
                                                  <PrivateBuycard saleData={index} user={false} connect={"string"} />

                                              ))
                                            }
                                          </div>
                                          <div className='text-center mt-3'>


                                            {isSearch ?
                                              <>
                                                {searchSale && searchSale?.length < this.state.searchProxy?.length ?

                                                  <button className="get-started-btn explore-btn" onClick={this.loadSearchMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                  : <></>
                                                }
                                              </> : <>
                                                {totalSales && totalSales?.length < this.state.proxy?.length ?
                                                  <button className="get-started-btn explore-btn" onClick={this.loadMoremycontribution.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                  : <></>
                                                }
                                              </>
                                            }

                                          </div>
                                        </> :

                                        <div className='row mt-5'>
                                          <div className='col-12'>
                                            <p className='no_data_txt'>No Data</p>
                                          </div>
                                        </div>
                                      }


                                    </div>
                                  </Tab.Pane>

                                  <Tab.Pane eventKey="fourth">
                                    <div className="tab_img">
                                      <div className='row_div'>
                                        <div>
                                          <div className='row_div'>
                                            <div>
                                              <div className='row justify-content-between align-items-end'>
                                                <div className='col-12 col-md-5 col-lg-5 chainpadsearch col-xl-4 mb-2 mb-md-0 mt-3'>
                                                  <p className='label_input invisible'>Search</p>

                                                  <input className="form-control allsearch searc_style_2" value={search} type="text" onChange={(e) => { this.setState({ search: e.target.value }); this.handleChange(e); }} onKeyDown={(e) => this.handleChange(e)} placeholder="Enter token name or token symbol" aria-label="Search" />
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M15.0237 13.9847L12.1904 11.1597C13.1045 9.99508 13.6006 8.55691 13.5987 7.07637C13.5987 5.75783 13.2077 4.46889 12.4752 3.37257C11.7426 2.27624 10.7014 1.42176 9.48327 0.917171C8.2651 0.412587 6.92466 0.280565 5.63145 0.5378C4.33824 0.795034 3.15036 1.42997 2.21801 2.36232C1.28566 3.29467 0.650717 4.48256 0.393482 5.77577C0.136247 7.06897 0.268269 8.40942 0.772854 9.62759C1.27744 10.8458 2.13192 11.887 3.22825 12.6195C4.32458 13.352 5.61351 13.743 6.93205 13.743C8.4126 13.7449 9.85076 13.2489 11.0154 12.3347L13.8404 15.168C13.9179 15.2461 14.01 15.3081 14.1116 15.3504C14.2131 15.3928 14.322 15.4145 14.4321 15.4145C14.5421 15.4145 14.651 15.3928 14.7525 15.3504C14.8541 15.3081 14.9462 15.2461 15.0237 15.168C15.1018 15.0906 15.1638 14.9984 15.2061 14.8968C15.2484 14.7953 15.2702 14.6864 15.2702 14.5764C15.2702 14.4664 15.2484 14.3574 15.2061 14.2559C15.1638 14.1543 15.1018 14.0622 15.0237 13.9847ZM1.93205 7.07637C1.93205 6.08746 2.2253 5.12076 2.7747 4.29852C3.32411 3.47627 4.105 2.83541 5.01863 2.45697C5.93226 2.07853 6.9376 1.97952 7.9075 2.17244C8.87741 2.36537 9.76832 2.84157 10.4676 3.54083C11.1668 4.2401 11.6431 5.13101 11.836 6.10092C12.0289 7.07082 11.9299 8.07615 11.5514 8.98979C11.173 9.90342 10.5321 10.6843 9.7099 11.2337C8.88766 11.7831 7.92096 12.0764 6.93205 12.0764C5.60597 12.0764 4.3342 11.5496 3.39652 10.6119C2.45883 9.67422 1.93205 8.40245 1.93205 7.07637Z" fill="#868686" />
                                                  </svg>
                                                </div>
                                                <div className='d-flex  fullside col-12 col-md-7 col-lg-7 col-xl-8 pt-3'>
                                                  <div className='filterbutton'>
                                                    <Dropdown className='dropdown_normal' >
                                                      {/* <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                        ETH, BSC, o…
                                                        <p className='label_input labelname'> Networks</p>
                                                      </Dropdown.Toggle> */}

                                                      {/* <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                        <Dropdown.Item ><p>All Status</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                      {/* <Dropdown.Item key={"up"}><p>ETH, BSC, o…</p></Dropdown.Item>
                                                        <Dropdown.Item><p>ETH, BSC, o…</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                      {/* <Dropdown.Item><p >ETH, BSC, o…</p></Dropdown.Item> */}
                                                      {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                      {/* </Dropdown.Menu> */}
                                                    </Dropdown></div>
                                                  <div className='filterbutton ml-3'>

                                                    <Dropdown className='dropdown_normal' >
                                                      <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                                        {this.state.filterdata}
                                                        <p className='label_input labelname'>Filter By</p>
                                                      </Dropdown.Toggle>

                                                      <Dropdown.Menu className='dropdown_normal_menu' key={"up"}>
                                                        <Dropdown.Item ><p onClick={(e) => this.handlefilter("All Status")}>All Status</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>KYC</Dropdown.Item> */}
                                                        <Dropdown.Item key={"up"}><p onClick={(e) => this.handlefilter("Upcoming")}>Upcoming</p></Dropdown.Item>
                                                        <Dropdown.Item><p onClick={(e) => this.handlefilter("Live")}>Live</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Filled</Dropdown.Item> */}
                                                        <Dropdown.Item><p onClick={(e) => this.handlefilter("Ended")}>Ended</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Cancelled</Dropdown.Item> */}
                                                      </Dropdown.Menu>
                                                    </Dropdown></div>
                                                  <div className='filterbutton ml-3'>
                                                    <Dropdown className='dropdown_normal'>
                                                      <Dropdown.Toggle variant="success" id="dropdown-basic-1">
                                                        {this.state.sortdata}
                                                        <p className='label_input labelname'>Sort By</p>
                                                      </Dropdown.Toggle>

                                                      <Dropdown.Menu className='dropdown_normal_menu'>
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("No Filter")}>No Filter</p></Dropdown.Item>
                                                        {/* <Dropdown.Item>Hard Cap</Dropdown.Item>
                      <Dropdown.Item>Soft Cap</Dropdown.Item>
                      <Dropdown.Item>LP Percent</Dropdown.Item> */}
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("Start Time")}>Start Time</p></Dropdown.Item>
                                                        <Dropdown.Item><p onClick={(e) => this.handlesort("End Time")}>End Time</p></Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </div>
                                                </div>
                                                {/* <div className='col-6 col-md-3 col-xl-2'>
                                                
                                                  
                                                </div> */}
                                              </div>

                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                      {this.state.favorites.length > 0 ?
                                        <>
                                          <div className='row mt-5 length_last'>

                                            {!isSearch ?

                                              (this.state.favorites && this.state.favorites.map((index) =>

                                                index.isWhitelisted === false ? <Buycard saleData={index} user={true} tokenInfo={this.state.tokenBalance} connect={"string"} /> :
                                                  <PrivateBuycard saleData={index} tokenInfo={this.state.tokenBalance} user={false} connect={"string"} />
                                              )) :
                                              (searchSale && searchSale.map((index) =>
                                                index._isWhitelisted === false ? <Buycard saleData={index} user={true} tokenInfo={this.state.tokenBalance} connect={"string"} /> :
                                                  <PrivateBuycard saleData={index} tokenInfo={this.state.tokenBalance} user={false} connect={"string"} />

                                              ))
                                            }
                                          </div>
                                          <div className='text-center mt-3'>


                                            {isSearch ?
                                              <>
                                                {searchSale && searchSale.length < this.state.searchProxy.length ?

                                                  <button className="get-started-btn explore-btn" onClick={this.loadSearchMore.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                  : <></>
                                                }
                                              </> : <>
                                                {this.state.favorites && this.state.favorites.length < this.state.favoriteCount ?
                                                  <button className="get-started-btn explore-btn" onClick={this.loadMoreFavorites.bind(this)} id="load_more_btn">{this.state.isLoading ? 'Loading...' : 'View More Pools'}</button>
                                                  : <></>
                                                }
                                              </>
                                            }

                                          </div>
                                        </> :
                                        <div className='row mt-5'>
                                          <div className='col-12'>
                                            <p className='no_data_txt'>No Data</p>
                                          </div>
                                        </div>
                                      }


                                    </div>
                                  </Tab.Pane>

                                </Tab.Content>
                              </div>
                            </Col>
                          </Row>
                        </Tab.Container>


                      </div>
                    </div>
                  </div>
                  {/* end ongoing_sec */}

                  {/* upcoming_sec */}
                  {/* <div className='upcoming_sec mt-5'>
            <div className="container container_custom">
                <div  className='top_heqad_sec'>
                <div className='text-right'>
                <input className="form-control searc_style_1" type="text" placeholder="&#xF002; Project Name" aria-label="Search" />
                </div>
                  <div className="row py-3">
                      <div className="col-12 col-md-12 flex_cen_col">
                        <p className="banner_title text-center">Upcoming IDOs</p>
                        <hr className='hr_yellow mt-5'/>
                      </div>
                    
                  </div>
                </div>
            </div>
           
            <div className="inner_bg mt-4">
            <div className="container container_custom">


            <div className='row  justify-content-between'>
             
            <Buycard connect={"string"} />
            <Buycard connect={"string"} />
            </div>
            <div className='text-center mt-3'>

            <button className="get-started-btn" id="load_more_btn_1">Load More</button>
            <img src={loader}  id="loader_div_sm_1" className='d-none'/>
            </div>
                </div>
            </div>
            </div> */}
                  {/* end upcoming_sec */}

                  <Container className='pb-5 px-0'>

                    <center>
                      <small className="mt-0 bottom_text">
                        Disclaimer: The information provided shall not in any way
                        constitute a recomendation as to whether you should invest
                        in any product discussed. We accept no liability for any
                        loss occasioned to any person acting or refraining from
                        action as a result of any material provided or published.
                      </small>
                    </center>
                  </Container>
                </div>
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    )
  }
}

export default LaunchpadList1